import styled from 'styled-components';

export const Title = styled.div<{ fontSize: number; color: string }>`
  font-size: ${(props) => `${props.fontSize}px`};
  padding-top: 0px;
  width: 100%;
  color: ${(props) => props.color};
`;
